






































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import Confirm from '@/components/Confirm.vue'
import { TemplateModule } from '@/store/modules/template.module'
import { ETemplateType, EUserPermissions, ITemplate } from '@zunta/configurations'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Api from '@/api'
import { User } from '@/classes/User'
import Table from '@/components/tables/Table.vue'
import Card from '@/components/Card.vue'

@Component({
  components: {
    Card,
    Table,
    Icon,
    DateTimeLabel,
    Confirm
  }
})
export default class SettingsTemplate extends Vue {
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)
  EUserPermissions: any = EUserPermissions

  user: User = Api.getUser() as User

  isDeleting: boolean = false
  selectedTemplateForDelete: ITemplate | null = null
  showDeletedNotification: string | null = null

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: true,
    usePagination: true,
    fetchFunction: this.templateModuleInstance.fetchTemplates,
    rowClick: this.goTemplate,
    maxHeight: 'calc(100vh - 365px)',
    minHeight: 'calc(100vh - 365px)',
    columns: [
      {
        minWidth: '200px',
        width: 15,
        key: 'type',
        searchKey: 'type',
        label: 'Type',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.select,
        options: this.templateTypeList
      },
      {
        minWidth: '200px',
        width: 30,
        key: 'templateName',
        searchKey: 'templateName',
        label: 'Name',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '300px',
        width: 35,
        key: 'text',
        searchKey: 'text',
        label: 'Text',
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '200px',
        width: 20,
        key: 'updatedAt',
        searchKey: 'updatedAt',
        label: 'Last Updated',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '50px',
        width: 5,
        class: 'text-right',
        key: 'actions'
      }
    ]
  }

  get templateList () {
    return this.$store.state.template.templates
  }

  get templatesTotal () {
    return this.$store.state.template.templatesTotal
  }

  get templateTypeList () {
    return [
      {
        key: ETemplateType.LETTER,
        value: ETemplateType.LETTER,
        content: 'Letter'
      },
      {
        key: ETemplateType.MESSAGE,
        value: ETemplateType.MESSAGE,
        content: 'Message'
      },
      {
        key: ETemplateType.LETTER_PDF,
        value: ETemplateType.LETTER_PDF,
        content: 'Letter Upload'
      }
    ]
  }

  openDeleteConfimration (template: ITemplate) {
    this.selectedTemplateForDelete = template
  }

  closeConfirmDeleting () {
    this.selectedTemplateForDelete = null
  }

  async deleteOneTemplate () {
    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_TEMPLATES)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: 'Modify Template',
        icon: 'warning'
      })
      return
    }
    if (!this.selectedTemplateForDelete) {
      return
    }
    try {
      this.isDeleting = true
      await this.templateModuleInstance.deleteTemplate(this.selectedTemplateForDelete.id)
      this.showDeletedNotification = this.selectedTemplateForDelete.type
      // @ts-ignore
      await this.$refs.table.initSearch()
    } finally {
      this.isDeleting = false
      this.selectedTemplateForDelete = null
    }
  }

  getTemplateTypeLabel (type: ETemplateType) {
    const LABEL_MAP = {
      [ETemplateType.LETTER]: 'Letter',
      [ETemplateType.MESSAGE]: 'Message',
      [ETemplateType.LETTER_PDF]: 'Letter Upload'
    }
    return LABEL_MAP[type]
  }

  getTemplateBody (html: string) {
    const div = document.createElement('div')
    div.innerHTML = html
    let bodyEl = (div.querySelector('p') as any)
    if (!bodyEl) {
      return ''
    }
    return bodyEl.innerText
  }

  goTemplate (template: ITemplate) {
    this.$locationManager.rememberAndGoTo({
      name: 'management-template',
      params: {
        templateId: template.id.toString()
      }
    })
  }

  goAddTemplate () {
    this.$locationManager.rememberAndGoTo({ name: 'management-template', params: { templateId: 'new' } })
  }
}
